var map = {
	"./BLACK.png": 2471,
	"./BLUE.png": 6209,
	"./BROWN.png": 5690,
	"./CHARTREUSE.png": 9791,
	"./CORAL.png": 8590,
	"./GOLD.png": 421,
	"./GOLDENROD.png": 2901,
	"./GOLD_BORDER.png": 2329,
	"./GRAY.png": 798,
	"./GREEN.png": 386,
	"./INDIGO.png": 2613,
	"./LIGHT_GRAY.png": 949,
	"./LIGHT_GREEN.png": 6937,
	"./MAGENTA.png": 2806,
	"./ORANGE.png": 2355,
	"./PURPLE.png": 8558,
	"./RED.png": 5039,
	"./SILVER.png": 9102,
	"./SILVER_FRAMELESS.png": 5985,
	"./TEAL.png": 2802
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7159;